import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { lastValueFrom } from "rxjs";
import { ConfirmDialogComponent } from "src/app/components";

import { TextConstants } from "@shared/constants";
import { ConfirmDialogSubmitButtonMode } from "@shared/types";

@Injectable({
  providedIn: "root",
})
export class CanDeactiveDialogService {
  constructor(private dialog: MatDialog) {}

  async showDialog(submitButtonMode: ConfirmDialogSubmitButtonMode) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "600px", // needs to be wider to fit buttons in french
      data: {
        title: TextConstants.EXIT_CONFIRMATION,
        contentText: $localize`:@@confirm.services.savechangesbeforeleaving:You're about to leave this page. Would you like to save the changes you have made before leaving it?`,
        confirmButtonText: $localize`:@@action.services.saveleave:Save & leave`,
        confirmButtonIcon: "check",
        cancelButtonText: TextConstants.CANCEL,
        thirdActionButtonColor: "danger",
        thirdActionButtonText: $localize`:@@services.discardchanges:Discard changes`,
        submitButtonMode,
      },
    });

    return await lastValueFrom(dialogRef.afterClosed());
  }

  async showUploadConfirmationDialog(dialogText?: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: TextConstants.EXIT_CONFIRMATION,
        contentText:
          dialogText ??
          $localize`:@@confirm.services.uploadinprogressexit:Upload in progress. Are you sure that you want to exit?`,
        confirmButtonText: TextConstants.DISCARD_CHANGES_LEAVE,
        confirmButtonColor: "danger",
        confirmButtonIcon: "logout",
      },
    });

    return await lastValueFrom(dialogRef.afterClosed());
  }

  async showOverlayMenuDialog(submitDisabled: boolean) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "600px", // needs to be wider to fit buttons in french
      data: {
        title: $localize`:@@action.services.changemenuconfirmation:Change menu confirmation`,
        contentText: $localize`:@@confirm.services.leavesectionsavechanges:You're about to leave this section. Would you like to save the changes you have made before leaving it?`,
        confirmButtonText: $localize`:@@action.services.saveleave:Save & leave`,
        confirmButtonIcon: "check",
        cancelButtonText: TextConstants.CANCEL,
        thirdActionButtonColor: "danger",
        thirdActionButtonText: $localize`:@@services.discardchanges:Discard changes`,
        isSubmitButtonDisabled: submitDisabled,
      },
    });

    return await lastValueFrom(dialogRef.afterClosed());
  }
}
